export const manifest = {
  screens: {
    scr_rzvpxh: { name: "Home", route: "/" },
  },
}
